export const appRoutes = {
    'home': '/',
    'about': '/about-us',
    'blog': '/blog',
    'shop': '/shop',
    'contact': '/contact-us',
    'checkout': '/check-out',
    'payment': '/payment',
    'terms-of-service': '/terms-of-service',
    'privacy-policy': '/privacy-policy'
}